import { useGetFacilityLogoQuery } from "Api/Queries/Merchants/useGetFacilityLogoQuery";
import { useUploadFacilityLogoMutation } from "Api/Mutations/Merchants/useUploadFacilityLogoMutation";
import { useDeleteFacilityLogoMutation } from "Api/Mutations/Merchants/useDeleteFacilityLogoMutation";
import { FormAccordionSection } from "Components/Shared/FormAccordionSection";
import { ImageUpload } from "Components/Shared/ImageUpload/ImageUpload";
import PaypointImage from "Assets/Images/Images/moone-paypoint.svg";
import { Resources, useResource } from "Translations/Resources";
import { useState } from "react";
import { toast } from "sonner";

const COMPONENT_RESOURCES = Resources.Components.Merchant.Logo;

type Props = {
  merchantPublicID: string;
  facilityPublicID: string;
  logoFileName?: string | null;
  onLogoChange?: () => void;
};

export const FacilityLogoUpload = ({
  merchantPublicID,
  facilityPublicID,
  logoFileName,
  onLogoChange,
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useResource();
  const { logoUrl } = useGetFacilityLogoQuery({
    merchantPublicID,
    facilityPublicID,
    enabled: !!logoFileName,
  });
  const { mutate: uploadLogo, isPending: isUploading } =
    useUploadFacilityLogoMutation({
      onSuccess: () => {
        onLogoChange?.();
        toast.success(t(COMPONENT_RESOURCES.UploadSuccess));
      },
      onError: () => toast.error(t(COMPONENT_RESOURCES.UploadError)),
    });
  const { mutate: deleteLogo, isPending: isDeleting } =
    useDeleteFacilityLogoMutation({
      onSuccess: () => {
        onLogoChange?.();
        toast.success(t(COMPONENT_RESOURCES.DeleteSuccess));
      },
      onError: () => toast.error(t(COMPONENT_RESOURCES.DeleteError)),
    });

  return (
    <FormAccordionSection
      legend={t(COMPONENT_RESOURCES.FacilityTitle)}
      isExpanded={isExpanded}
      onToggle={() => setIsExpanded((prev) => !prev)}
      hideIncompleteIcon
    >
      <ImageUpload
        imageUrl={logoUrl}
        isPending={isUploading || isDeleting}
        onUpload={(file) =>
          uploadLogo({ merchantPublicID, facilityPublicID, file })
        }
        onDelete={() => deleteLogo({ merchantPublicID, facilityPublicID })}
        placeholder={PaypointImage}
        hint={t(COMPONENT_RESOURCES.Hint)}
      />
    </FormAccordionSection>
  );
};
